import React, { useState, useEffect } from 'react';

/**
 * LoginSlideshow Component
 * 
 * Displays a slideshow of artwork images on the right side of the login page.
 * Automatically transitions between images.
 */
const ARTWORKS = Array.from({ length: 24 }, (_, index) => ({
  id: index + 1,
  title: 'Aurelia',
  artist: `Scene ${index + 1}`,
  year: '',
  image: `/assets/login/aurelia/aurelia-scene-${String(index).padStart(2, '0')}.avif`,
}));
const TRANSITION_DURATION_MS = 1400;

function LoginSlideshow() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [previousIndex, setPreviousIndex] = useState(null);
  const [slideActive, setSlideActive] = useState(false);

  // Auto-advance slideshow every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        setPreviousIndex(prevIndex);
        setSlideActive(false);
        return (prevIndex + 1) % ARTWORKS.length;
      });
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (previousIndex === null) return undefined;

    const frame = requestAnimationFrame(() => {
      setSlideActive(true);
    });
    const timeout = setTimeout(() => {
      setPreviousIndex(null);
      setSlideActive(false);
    }, TRANSITION_DURATION_MS);

    return () => {
      cancelAnimationFrame(frame);
      clearTimeout(timeout);
    };
  }, [previousIndex]);

  const visibleArtworks = previousIndex === null
    ? [{ artwork: ARTWORKS[currentIndex], index: currentIndex, isCurrent: true }]
    : [
        { artwork: ARTWORKS[previousIndex], index: previousIndex, isCurrent: false },
        { artwork: ARTWORKS[currentIndex], index: currentIndex, isCurrent: true },
      ];

  return (
    <div className="relative h-full w-full overflow-hidden">
      {/* Image Container - Edge to Edge with all images for smooth transitions */}
      <div className="absolute inset-0">
        {visibleArtworks.map(({ artwork, index, isCurrent }) => (
          <img
            key={artwork.id}
            src={artwork.image}
            alt={artwork.title}
            className={`absolute inset-0 h-full w-full object-cover transition-transform ease-in-out ${
              previousIndex === null
                ? 'translate-x-0'
                : isCurrent
                  ? slideActive
                    ? 'translate-x-0'
                    : '-translate-x-full'
                  : slideActive
                    ? 'translate-x-full'
                    : 'translate-x-0'
            }`}
            style={{ transitionDuration: `${TRANSITION_DURATION_MS}ms` }}
            {...{ fetchpriority: index === 0 ? 'high' : 'auto' }}
          />
        ))}
      </div>
    </div>
  );
}

export default LoginSlideshow;
